// File: src/components/icons/RocketIcon.js
import React from 'react';

/**
 * Simple inline-SVG rocket silhouette used for the scroll-between-sections
 * control. Replaces a hotlinked icons8.com PNG so the UI doesn't depend on
 * a third-party CDN being reachable.
 *
 * This only swaps the image source — className, style, onClick, etc. are
 * spread onto the <svg> the same way they were applied to the old <img>,
 * so positioning/behavior/CSS (.rocket / .rocket-wrapper) are unaffected.
 */
const RocketIcon = ({ className, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="#ffffff"
    className={className}
    aria-hidden="true"
    {...props}
  >
    {/* Body */}
    <path d="M12 1.5c2.6 2.2 4 5.4 4 9.2 0 2.1-.4 3.9-1 5.4h-6c-.6-1.5-1-3.3-1-5.4 0-3.8 1.4-7 4-9.2z" />
    {/* Nose highlight / window */}
    <circle cx="12" cy="9.5" r="1.6" fill="#0d1b2a" />
    {/* Left fin */}
    <path d="M9 13.5c-1.8.2-3.2 1.4-3.8 4.3 1.8-.6 3.1-1.4 3.9-2.5z" />
    {/* Right fin */}
    <path d="M15 13.5c1.8.2 3.2 1.4 3.8 4.3-1.8-.6-3.1-1.4-3.9-2.5z" />
    {/* Base */}
    <path d="M9 16.1h6l-.9 2.9H9.9z" />
    {/* Flame */}
    <path d="M12 19c.9 1 1.4 2.1 1.2 3.5-.4-.4-.8-.6-1.2-.6s-.8.2-1.2.6c-.2-1.4.3-2.5 1.2-3.5z" />
  </svg>
);

export default RocketIcon;
